import * as S from './style'

export default function Old2017() {
  return (
    <S.Wrapper src="https://2017.glamstar.com.br/" frameBorder="0"></S.Wrapper>
  )
}
